// File: views/LandingPage.jsx
import React, { useEffect, useRef, useState } from 'react';
import styles from '../styles/LandingPage.module.css';

import LandingHero from './Landing/LandingHero';
import Testimonials from './Landing/Testimonials';
import BottomNav from './Landing/BottomNav';

function useScrollFade(scope) {
  useEffect(() => {
    if (!scope.current) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add(styles.inView);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    scope.current.querySelectorAll('[data-anim]').forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [scope]);
}

function useScrollSpy(scope, setActive) {
  useEffect(() => {
    if (!scope.current) return;
    const sections = scope.current.querySelectorAll('section[id]');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.id;
          const threshold = id === 'testimonials' ? 0.18 : 0.32;
          if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
            setActive(id);
          }
        });
      },
      { threshold: [0.12, 0.18, 0.28, 0.38, 0.5], rootMargin: '-12% 0px -12% 0px' }
    );
    sections.forEach((s) => io.observe(s));
    return () => io.disconnect();
  }, [scope, setActive]);
}

const smoothScroll = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

export default function LandingPage() {
  const ref = useRef(null);
  const [active, setActive] = useState('home');
  const [wizardOpen, setWizardOpen] = useState(false);
  const [wizardService, setWizardService] = useState(null);
  const [referralUsername, setReferralUsername] = useState(null);
  const [wizardSession, setWizardSession] = useState(0);

  useScrollFade(ref);
  useScrollSpy(ref, setActive);

  useEffect(() => {
    const r = new URLSearchParams(window.location.search).get('r');
    if (r?.trim()) {
      setReferralUsername(r.trim());
    }
  }, []);

  const switchTo = (id) => {
    setActive('');
    smoothScroll(id);
    setTimeout(() => setActive(id), 300);
  };

  const openWizard = (service) => {
    setWizardService(service);
    setWizardSession((k) => k + 1);
    setWizardOpen(true);
    setActive('home');
  };

  const closeWizard = () => {
    setWizardOpen(false);
    setWizardService(null);
  };

  return (
    <div ref={ref} className="landingPageRoot">
      <LandingHero
        onNav={switchTo}
        onChoosePath={openWizard}
        wizardOpen={wizardOpen}
        wizardService={wizardService}
        referralUsername={referralUsername}
        wizardSession={wizardSession}
        onCloseWizard={closeWizard}
      />
      {!wizardOpen && <Testimonials />}
      {!wizardOpen && <BottomNav active={active} onNav={switchTo} />}
    </div>
  );
}
